import { useTranslation } from 'react-i18next';

const StructuredData = () => {
  const { t, i18n } = useTranslation();

  // Only show structured data for English, as the app is primarily English
  if (i18n.language !== 'en') {
    return null;
  }

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": t('faq.q1.question'),
        "acceptedAnswer": {
          "@type": "Answer",
          "text": t('faq.q1.answer')
        }
      },
      {
        "@type": "Question",
        "name": t('faq.q2.question'),
        "acceptedAnswer": {
          "@type": "Answer",
          "text": t('faq.q2.answer')
        }
      },
      {
        "@type": "Question",
        "name": t('faq.q3.question'),
        "acceptedAnswer": {
          "@type": "Answer",
          "text": t('faq.q3.answer')
        }
      },
      {
        "@type": "Question",
        "name": t('faq.q4.question'),
        "acceptedAnswer": {
          "@type": "Answer",
          "text": t('faq.q4.answer')
        }
      },
      {
        "@type": "Question",
        "name": t('faq.q5.question'),
        "acceptedAnswer": {
          "@type": "Answer",
          "text": t('faq.q5.answer')
        }
      },
      {
        "@type": "Question",
        "name": t('faq.q6.question'),
        "acceptedAnswer": {
          "@type": "Answer",
          "text": t('faq.q6.answer')
        }
      },
      {
        "@type": "Question",
        "name": t('faq.q7.question'),
        "acceptedAnswer": {
          "@type": "Answer",
          "text": t('faq.q7.answer')
        }
      },
      {
        "@type": "Question",
        "name": t('faq.q8.question'),
        "acceptedAnswer": {
          "@type": "Answer",
          "text": t('faq.q8.answer')
        }
      },
      {
        "@type": "Question",
        "name": t('faq.q9.question'),
        "acceptedAnswer": {
          "@type": "Answer",
          "text": t('faq.q9.answer')
        }
      },
      {
        "@type": "Question",
        "name": t('faq.q10.question'),
        "acceptedAnswer": {
          "@type": "Answer",
          "text": t('faq.q10.answer')
        }
      }
    ]
  };

  const appSchema = {
    "@context": "https://schema.org",
    "@type": "MobileApplication",
    "name": "TripReel",
    "alternateName": ["TripReel Travel Videos", "TripReel App", "Travel Map Animation App", "Trip Highlight Video App", "Trip Recap Video App", "Journey Route Animator App", "Travel Recap App", "Animated Travel Map App", "Travel Route Animation App", "Map Journey Video App", "Travel Story Maker App", "Trip Animation App"],
    "description": t('hero.description'),
    "url": "https://tripreel.app/",
    "applicationCategory": "TravelApplication",
    "operatingSystem": "iOS, Android",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "ratingCount": "1250"
    },
    "screenshot": "https://tripreel.app/screenshot-preview.png",
    "author": {
      "@type": "Organization",
      "name": "TripReel"
    },
    "inLanguage": i18n.language,
    "featureList": [
      t('features.twoTap.description'),
      t('features.smartTrip.description'),
      t('features.privacy.description'),
      t('features.offline.description'),
      t('features.customize.description'),
      t('features.share.description')
    ],
    "softwareRequirements": "iOS 14.0+ or Android 8.0+",
    "releaseNotes": t('hero.description')
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(appSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>
    </>
  );
};

export default StructuredData;